'use client';

import { Tooltip } from '../Tooltip';

import styles from './SecondaryButton.module.scss';

type BaseProps = {
  ariaLabel: string;
  onClick?: () => void;
  backgroundOverride?: 'theme' | 'emphasis';
  style?: React.CSSProperties;
  disabled?: boolean;
};

type IconOnlyProps = BaseProps & {
  variant: 'mini' | 'medium';
  children: React.ReactElement; // * Icon only.
};

type FullProps = BaseProps & {
  variant?: 'full';
  children: React.ReactNode; // * Icon + text OR text only.
};

type SecondaryButtonProps = IconOnlyProps | FullProps;

export function SecondaryButton({
  children,
  ariaLabel,
  variant = 'full',
  backgroundOverride = 'theme',
  onClick = () => {},
  style = {},
  disabled = false,
}: SecondaryButtonProps) {
  const btn = (
    <button
      type="button"
      tabIndex={0}
      className={`
        ${styles.secondaryButton}
        ${styles[variant]}
        ${backgroundOverride === 'emphasis' ? styles.backgroundEmphasis : ''}
        ${disabled ? styles.disabled : ''}
      `}
      aria-label={ariaLabel}
      onClick={onClick}
      style={style}
      disabled={disabled}
    >
      {children}
    </button>
  );

  if (variant === 'mini' || variant === 'medium') {
    return (
      <Tooltip title={ariaLabel} placement="top">
        <span style={{ display: 'inline-flex' }}>{btn}</span>
      </Tooltip>
    );
  }

  return btn;
}
